
    // this file was auto generated by python script
    import UserCheck from './UserCheck';
    export default UserCheck;
    